export default "__VITE_ASSET__BxFoek2B__"